import { EstadoBodega, TipoEntrega } from "helper/const";

export default function invalidClass(error) {
  return `${error === true || error?.length > 0 ? "is-invalid" : ""}`;
}

export const formikExtra = {
  upperCase: (name, formik) => {
    return {
      onChange: (e) => {
        const { selectionStart } = e.target;

        /*
        react js formik input jump cursor
        https://www.google.com/search?q=react+js+formik+input+jump+cursor&client=firefox-b-d&hs=eMFV&sca_esv=c238079dbba20b5b&sxsrf=ANbL-n6lJBq_YzsDwfsnExEPIg8zN2xHCA%3A1779125714814&ei=0k0LauOoMezHkPIP-bX-kAc&biw=1453&bih=954&ved=0ahUKEwjj2ffhr8OUAxXsI0QIHfmaH3IQ4dUDCBI&uact=5&oq=react+js+formik+input+jump+cursor&gs_lp=Egxnd3Mtd2l6LXNlcnAiIXJlYWN0IGpzIGZvcm1payBpbnB1dCBqdW1wIGN1cnNvcjIFECEYoAEyBRAhGKABSMviIFDVCljt3yBwAngBkAEAmAHvAqABuhmqAQg3LjE3LjAuMbgBA8gBAPgBAZgCGqAC3BnCAgoQABhHGNYEGLADwgIIECEYoAEYwwTCAggQABgIGB4YDcICBRAAGO8FwgIKECEYChigARjDBMICCBAAGIAEGKIEwgIIEAAYFhgeGArCAgYQABgWGB7CAgUQIRifBcICBBAhGBWYAwCIBgGQBgeSBwg4LjE3LjAuMaAH4mCyBwg2LjE3LjAuMbgHzBnCBwcwLjEwLjE2yAdSgAgB&sclient=gws-wiz-serp
        */
        //      onChange={(e)=>{ const value = e.target.value || ""; setFieldValue('email', value.toLowerCase()); }}
        const value = e.target.value || "";
        formik.setFieldValue(name, value.toUpperCase());

        // Restore cursor position in the next frame
        window.requestAnimationFrame(() => {
          e.target.selectionStart = selectionStart;
          e.target.selectionEnd = selectionStart;
        });
      },
    };
  },
};

const ASOCIADO_STATES = {
  ACTIVO: {
    id: 2,
    class: "bg-success",
    text: "ACTIVO",
    style: {},
  },
  INACTIVO: {
    id: 1,
    class: "bg-danger",
    text: "INACTIVO",
    style: {},
  },
  CONGELADO: {
    id: 3,
    class: "",
    text: "CONGELADO",
    style: { backgroundColor: "#0dcaf0" },
  },
};

export const ORDEN_VENTA_ESTADOS = {
  EN_PROCESO: {
    id: 1,
    class: "bg-secondary",
    text: "EN PROCESO",
    style: {},
  },
  LISTO_PARA_RECOGER: {
    id: 2,
    class: "btn-own-orange",
    text: "Listo Para Recoger",
    style: {},
  },
  LISTO_PARA_ENTREGA: {
    id: 3,
    class: "btn-own-yellow",
    text: "Listo Para Entrega",
    style: {},
  },
  COMPLETADO: {
    id: 4,
    class: "bg-success",
    text: "COMPLETADO",
    style: {},
  },
};

export const handleOrdenVentaEstados = (item) => {
  if (item == null) return {};

  const found = Object.entries(ORDEN_VENTA_ESTADOS).find(
    (a) => a[1].id === item.estadoOrden.id,
  );
  if (found == null) return {};

  return found[1];
};

export const ORDEN_VENTA_STATUS = {
  EN_PROCESO: {
    id: 1,
    class: "bg-secondary",
    text: "EN PROCESO",
    style: {},
  },
  CANCELADO: {
    id: 2,
    class: "bg-danger",
    text: "CANCELADO",
    style: {},
  },
  COMPLETADO: {
    id: 3,
    class: "bg-success",
    text: "COMPLETADO",
    style: { backgroundColor: "#0dcaf0" },
  },
  DEVOLUCION: {
    id: 4,
    class: "btn-own-purple",
    text: "DEVOLUCION",
    style: {},
  },
};

export const PROMOCIONES_STATES = {
  VENTA_INTERNA: {
    id: 3,
  },
  REGALO_EN_COMPRA: {
    id: 4,
  },
  CONGELADO: {
    id: 30,
  },
};

export const METODO_DE_PAGOS = {
  PLAZOS_QUINCENALES_ID: 1,
  CONTADO_TERMINAL_ID: 2,
  CONTADO_SITIO_ID: 3,
  CONTADO_EFECTIVO_ID: 4,
  CONTADO_MERCADO_PAGO_ID: 5,
};

export const FORMA_DE_PAGOS = {
  EFECTIVO_ID: 1,
  TRANSFERENCIA_ID: 2,
  MERCADO_PAGO_ID: 3,
  APLAZO_ID: 4,
  PAYPAL_ID: 5,
};

export const handleOrdenVentaStatus = (item) => {
  if (item == null) return {};

  const found = Object.entries(ORDEN_VENTA_STATUS).find(
    (a) => a[1].id === item.estatuOrden.id,
  );
  if (found == null) return {};

  return found[1];
};

export const handleStatus = (item) => {
  if (item == null) return {};

  const congelado = item.congelado ?? false;
  if (congelado) {
    return ASOCIADO_STATES.CONGELADO;
  }

  const activo = item.activo ?? false;
  let statusInfo = ASOCIADO_STATES.ACTIVO;
  if (!activo) {
    statusInfo = ASOCIADO_STATES.INACTIVO;
  }

  return statusInfo;
};

export const handleStatusExtra = (status) => {
  const styleStatus = {
    Approved: "success",
    Pending: "warning",
    Reject: "danger",
  };

  return styleStatus[status] ?? "success";
};

export const handleEstadoBodega = (status) => {
  const Apartado = EstadoBodega.Apartado;
  const EnProceso = EstadoBodega.EnProceso;
  const Surtido = EstadoBodega.Surtido;
  const styleStatus = {};
  styleStatus[Apartado] = "warning";
  styleStatus[EnProceso] = "secondary";
  styleStatus[Surtido] = "success";

  return styleStatus[status] ?? "success";
};

EstadoBodega.EnProceso = 1;
EstadoBodega.Apartado = 2;
EstadoBodega.Surtido = 3;

export const handleTipoEntrega = (tipoId) => {
  const Local = TipoEntrega.Local;
  const Foranea = TipoEntrega.Foranea;

  const styleStatus = { class: "", style: {} };
  styleStatus[Local] = { class: "", style: { backgroundColor: "#2ECC71" } };
  styleStatus[Foranea] = { class: "", style: { backgroundColor: "#3498DB" } };

  return styleStatus[tipoId] ?? {};
};

export const NivelOptions = {
  PLATA: {
    id: 2,
    class: "bg-plata",
  },
  BRONCE: {
    id: 1,
    class: "bg-bronce",
  },
  ORO: {
    id: 3,
    class: "bg-oro",
  },
};

export const handleNivel = (nivelId) => {
  const found = Object.keys(NivelOptions).find(
    (element) => NivelOptions[element].id === nivelId,
  );
  if (!found) return "";

  return NivelOptions[found].class;
};

export const FilterReportePresets = {
  HOY: 1,
  ESTA_SEMANA: 2,
  ESTE_MES: 3,
  ULTIMOS_3_MESES: 4,
};

export function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

export function hasDatePassedXDays(targetDate, xDays) {
  // Get the current date
  const now = new Date();

  // Calculate the date 'xDays' ago from now
  const xDaysAgo = new Date(now);
  xDaysAgo.setDate(now.getDate() - xDays);

  // Compare the targetDate with the date 'xDaysAgo'
  // If targetDate is earlier than xDaysAgo, it means it has passed xDays
  return targetDate < xDaysAgo;
}
